@if (dataPointsForChart$ | async) {
  <app-chart-tile
    [title]="title"
    [getSeries]="getSeries"
    [options]="options"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
